
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/articles/[slug]",
      function () {
        return require("private-next-pages/magazine/articles/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/articles/[slug]"])
      });
    }
  